import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NextIntlClientProvider } from "next-intl";
import { Toaster } from "sonner";
import { ThemeProvider } from "next-themes";
import ko from "../vendor/src/shared/i18n/messages/ko.json";
import { EngineWorkbench } from "./EngineWorkbench";
import { LocalExportAudit } from "./LocalExportAudit";
import { LinkedWork } from "./LinkedWork";
import {EditorErrorBoundary as Boundary} from './EditorErrorBoundary';
import "./style.css";

const queries: QueryClient = import.meta.hot?.data.editorQueries ?? new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});
const root: ReturnType<typeof createRoot> = import.meta.hot?.data.editorRoot ?? createRoot(document.getElementById('root')!);
if (import.meta.hot) import.meta.hot.dispose((data) => {
  data.editorRoot = root;
  data.editorQueries = queries;
});
const fixtureKind = new URLSearchParams(window.location.search).get("fixture");
const fixtureMode =
  import.meta.env.DEV &&
  (fixtureKind === "1" ||
    fixtureKind === "source-caption" ||
    fixtureKind === "local-export");
root.render(
  <Boundary>
    <QueryClientProvider client={queries}>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <NextIntlClientProvider locale="ko" messages={ko} timeZone="Asia/Seoul">
          {fixtureMode ? (
            fixtureKind === "local-export" ? (
              <LocalExportAudit />
            ) : (
              <EngineWorkbench
                sourceCaption={fixtureKind === "source-caption"}
              />
            )
          ) : (window.parent !== window || (new URLSearchParams(window.location.search).get('standalone')==='1')) && new URLSearchParams(window.location.search).has('hostOrigin') ? (
            <LinkedWork />
          ) : (
            <main role="status">
              <h1>와카 작업 연결이 필요합니다.</h1>
              <p>
                기존 작업 화면에서 정밀 편집을 열어 주세요. 이식 중인 화면이며
                저장된 작업물은 변경하지 않았습니다.
              </p>
            </main>
          )}
          <Toaster position="top-center" />
        </NextIntlClientProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </Boundary>,
);
